import baseRoute from '../baseRoute';

type RouteDefinition = typeof baseRoute;

export type * from './viewModel';

export const ROUTE: RouteDefinition = baseRoute;

export const URL = (): RouteDefinition => baseRoute;
